"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const label_1 = __importDefault(require("../label/label"));
const customerInfoConstants_1 = require("./customerInfoConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const tabs_1 = __importDefault(require("../tabs/tabs"));
const expandableBox_1 = __importDefault(require("../expandableBox/expandableBox"));
const eventConstants_1 = require("../../constants/eventConstants");
const constants_1 = require("../../constants/constants");
const userBankContent_1 = __importDefault(require("./userBankContent/userBankContent"));
const dateComponent_1 = __importDefault(require("../dateComponent/dateComponent"));
const icon_1 = __importDefault(require("../icon/icon"));
const colors_1 = __importDefault(require("../../styles/colors"));
const InternalLoanCustomerInfo = ({ loan }) => {
    const borrower = loan.borrowers[0];
    const [selectedTab, setSelectedTab] = react_1.useState(customerInfoConstants_1.CUSTOMER_INFO);
    const loanData = loan.loan_data;
    const disbursalBankAccount = {
        number: loanData.disbursement_account_number,
        name: loanData.disbursement_account_name,
        bank_name: loanData.disbursement_bank_name,
        status: '-',
    };
    const repaymentBankAccount = {
        number: loanData.repayment_account_number,
        name: loanData.repayment_account_name,
        bank_name: loanData.repayment_account_name,
        status: '-',
    };
    const customerInfoContent = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
            borrower.alternative_phone_numbers ? (react_1.default.createElement(label_1.default, { subheading: "Alternative Phone Number", title: borrower.alternative_phone_numbers[0] })) : null,
            react_1.default.createElement(label_1.default, { subheading: "Employment Status", title: borrower.employment_status }),
            react_1.default.createElement(label_1.default, { subheading: "Birth Date", title: borrower.date_of_birth ? react_1.default.createElement(dateComponent_1.default, { date: borrower.date_of_birth }) : 'Not Specified' }),
            react_1.default.createElement(label_1.default, { subheading: "LGA", title: borrower.lga || 'N/A' }),
            react_1.default.createElement(label_1.default, { subheading: "State", title: borrower.state || 'N/A' }))));
    const contactsContent = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
        loan.borrowers[0].contacts.length === 0 && (react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorGray }, `No contacts `)),
        loan.borrowers[0].contacts.map((contact) => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(label_1.default, { subheading: "Name", title: contact.name })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(label_1.default, { subheading: "Phone", title: contact.phone_number || 'N/A' })))))));
    let tabContent = null;
    if (selectedTab === customerInfoConstants_1.CUSTOMER_INFO) {
        tabContent = customerInfoContent;
    }
    else if (selectedTab === customerInfoConstants_1.CUSTOMER_CONTACTS) {
        tabContent = contactsContent;
    }
    else if (selectedTab === customerInfoConstants_1.REPAYMENT_BANK) {
        tabContent = (react_1.default.createElement(userBankContent_1.default, { bankAccount: repaymentBankAccount, subheading: "This is am account the user can pay money into to close their loan", title: "User Repayment Account" }));
    }
    else if (selectedTab === customerInfoConstants_1.DISBURSAL_BANK) {
        tabContent = (react_1.default.createElement(userBankContent_1.default, { bankAccount: disbursalBankAccount, subheading: "The loan was deposited into this bank account", title: "User Bank Account" }));
    }
    const tabs = [
        { key: customerInfoConstants_1.CUSTOMER_INFO, name: 'CUSTOMER INFO' },
        { key: customerInfoConstants_1.REPAYMENT_BANK, name: 'REPAYMENT BANK ACCOUNT' },
        { key: customerInfoConstants_1.DISBURSAL_BANK, name: 'DISBURSAL BANK ACCOUNT' },
        { key: customerInfoConstants_1.CUSTOMER_CONTACTS, name: 'CUSTOMER CONTACTS' },
    ];
    const header = (react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: react_native_1.Platform.OS === constants_1.WEB_TAG
            ? [styles_1.default.contentContainerStyle, styles_1.default.flexDirectionRow]
            : styles_1.default.flexDirectionRow },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexDirectionRow] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterCenter },
                react_1.default.createElement(react_native_paper_1.Avatar.Text, { label: borrower.first_name[0].concat(borrower.last_name[0]) })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
                react_1.default.createElement(label_1.default, { title: `${borrower.first_name} ${borrower.last_name}`, subheading: borrower.gender || '' })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                    react_1.default.createElement(react_native_paper_1.Chip, { style: { backgroundColor: colors_1.default.BLUE }, avatar: react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faStar, color: colors_1.default.WHITE }) },
                        react_1.default.createElement(react_native_1.View, { style: { marginTop: 2 } },
                            react_1.default.createElement(react_native_1.Text, { style: [styles_1.default.fontSizeText, { padding: 0, margin: 0 }] }, ` ${loanData.status} | ${loanData.product}`))),
                    react_1.default.createElement(react_native_paper_1.Subheading, null,
                        react_1.default.createElement(react_native_1.Text, { style: [styles_1.default.textColorGray, styles_1.default.fontSizeText] }, ` ${borrower.email} | ${borrower.phone_number}`)))))));
    const titleContent = (react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.fontWeightBold] }, `Customer Information `));
    const baseComponent = react_1.default.createElement(react_native_1.View, { style: { marginTop: 45, marginBottom: 10 } }, header);
    const expandedComponent = (react_1.default.createElement(react_1.default.Fragment, null,
        header,
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(tabs_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab, tabs: tabs }),
            react_1.default.createElement(react_native_1.View, null, tabContent))));
    return (react_1.default.createElement(expandableBox_1.default, { baseComponent: baseComponent, expandedComponent: expandedComponent, title: titleContent, eventName: eventConstants_1.CUSTOMER_INFO_EXPAND_PRESS, expandedOnFirstView: true }));
};
exports.default = InternalLoanCustomerInfo;
